module.exports = __webpack_public_path__ + "static/media/background.3d13a061.svg";